import '../../static/assets/css/pages/general/login/login-3.css'
import { mapState } from 'vuex'
import api from '../service/service.js'
import Swal from 'sweetalert2'
import VS from '../../static/version.json'

export default {
  data () {
    return {
      username: '',
      password: '',
      vss: VS.version
    }
  },
  computed: {
    ...mapState(['user', 'screenHeight'])
  },
  methods: {
    login () {
      let payload = {
        username: this.username,
        password: this.password
      }
      this.$store.state.isLoading = true
      api.login(
        payload,
        result => {
          console.log(JSON.stringify(result.data))
          if (result.result === true) {
            sessionStorage.Data = JSON.stringify(result.data)
            sessionStorage.Username = result.data.username
            this.alert_msg(
              'success',
              'เข้าสู่ระบบ',
              'ยินดีต้อนรับคุณ ' + result.data.username
            )
            setTimeout(() => {
              window.location = '/'
            }, 1000)
            // this.$router.push({name: 'home'})
          } else {
            this.$store.state.isLoading = false
            Swal.fire('Login Fail!', result.data, 'warning')
          }
        },
        error => {
          this.$store.state.isLoading = false
          Swal.fire('Login Fail!', JSON.stringify(error), 'error')
        }
      )
    }
  },
  mounted () {
    if (api.LoggedIn()) {
      window.location = '/'
    }
    this.$refs.username.focus()
  }
}



// WEBPACK FOOTER //
// ./src/js/login.js